import { render } from "./GeneralUser.vue?vue&type=template&id=3f2d01e5&scoped=true"
import script from "./GeneralUser.vue?vue&type=script&lang=js"
export * from "./GeneralUser.vue?vue&type=script&lang=js"

import "./GeneralUser.vue?vue&type=style&index=0&id=3f2d01e5&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2d01e5"]])

export default __exports__